<template>
  <div>
    <Modal v-model="show" :width="800">
      <p slot="header" class="text-center">资产详情</p>
      <h4 class="workplatform-title m-t-10 m-b-10">基础信息</h4>
      <Row :gutter="8" class="p-b-10">
        <i-col span="8">
          <label class="title">编号</label><span>{{ assetInfo.code }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">内部编号</label><span>{{ assetInfo.innerCode }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">所属类型</label>
          <span>{{ assetInfo.deviceBigmodelName + ' - ' + assetInfo.devicemodelName }}</span>
        </i-col>
      </Row>
      <Row :gutter="8" class="p-b-10">
        <i-col span="8">
          <label class="title">所属资产</label><span>{{ assetInfo.assetName }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">所属站点</label><span>{{ assetInfo.stationName }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">所属位置</label><span>{{ assetInfo.positionName }}</span>
        </i-col>
      </Row>
       <Row :gutter="8" class="p-b-10">
        <i-col span="8">
          <label class="title">楼层</label>
          <span>{{ assetInfo.floor }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">建筑面积</label><span>{{ assetInfo.area + ' ㎡' }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">使用面积</label>
          <span>{{ assetInfo.useArea + ' ㎡'}}</span>
        </i-col>
      </Row>
      <Row :gutter="8" class="p-b-10">
        <i-col span="8">
          <label class="title">长度</label><span>{{ assetInfo.width + ' ㎡' }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">宽度</label><span>{{ assetInfo.depth + ' ㎡' }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">高度</label><span>{{ assetInfo.height + ' ㎡' }}</span>
        </i-col>
      </Row>
      <Row :gutter="8" class="p-b-10">
        <i-col span="8">
          <label class="title">通水</label><span>{{ assetInfo.waterSupply===1? '是':'否' }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">通气</label><span>{{ assetInfo.gasSupply===1? '是':'否' }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">消防验收</label><span>{{ assetInfo.fireApproval===1? '是':'否' }}</span>
        </i-col>
      </Row>
      <Row :gutter="8" class="p-b-10">
        <i-col span="8">
          <label class="title">朝向</label><span>{{ assetInfo.orientationName }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">规划用途</label><span>{{ assetInfo.useName }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">设备设施</label>
          <span>{{ assetInfo.facilityNameList?assetInfo.facilityNameList.toString():'/' }}</span>
        </i-col>
      </Row>

      <Row :gutter="8" class="p-b-10">
        <i-col span="8">
          <label class="title">状态</label>
          <span>{{ assetInfo.enabledName }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">房屋所有权证编号</label>
          <span>{{ assetInfo.certNo }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">产权方</label>
          <span>{{ assetInfo.manageUnitName }}</span>
        </i-col>
      </Row>

      <Row :gutter="8" class="p-b-10">
        <i-col span="8">
          <label class="title">经营方</label>
          <span>{{ assetInfo.usingUnitName }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">创建时间</label>
          <span>{{ assetInfo.createTime }}</span>
        </i-col>
        <i-col span="8">
          <label class="title">最后更新时间</label>
          <span>{{ assetInfo.updateTime }}</span>
        </i-col>
      </Row>
      <Row :gutter="8" class="p-b-10">
        <i-col span="24">
          <label class="title">备注</label>
          <span>{{ assetInfo.remark||'/' }}</span>
        </i-col>
      </Row>
    </Modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      show: false,
      assetInfo: {}
    }
  },
  computed: {
    usagesTime () {
      if (this.assetInfo.usagesTime && this.assetInfo.usagesTime !== '' && Array.isArray(JSON.parse(this.assetInfo.usagesTime))) {
        const times = JSON.parse(this.assetInfo.usagesTime)
        return `${times[0]} - ${times[1]}`
      } else {
        return '/'
      }
    }
  },
  methods: {
    showModal (obj) {
      this.assetInfo = obj
      this.show = true
    }
  }
}
</script>
